import { type ApiClient } from "@anna-money/anna-web-lib/api";
import { ComplianceData } from "./complianceTypes";

export class ComplianceClient {
  private readonly _apiClient: ApiClient;

  constructor(apiClient: ApiClient) {
    this._apiClient = apiClient;
  }

  async getComplianceResult(directorId?: string): Promise<ComplianceData> {
    const url = directorId ? `api/formations/v2/compliance?director_id=${directorId}` : "api/formations/v2/compliance";
    const response = await this._apiClient.get(url);
    return response.getData(ComplianceData);
  }
}
